import fetchServer from "../fetchServer";
import { store } from "../../redux/store";

export default async function getCRMData(cancelToken) {
  let result = {return: 0,msg: 'Something went wrong updating profile!'}
  const userData = store.getState().user.userData;
  const token =  userData?.agent?.token; 

  const headers = {};
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  console.log('getCRMData: ',token,headers)

  await fetchServer({method: 'GET',url: '/main/v1/crm',cancelToken: cancelToken || undefined, headers: headers})
  .then((res) => {
    if(res?.data && !res?.data?.error) {
      result = {return: 1,msg: 'Successfull',data: res.data.data}
    } else result['msg'] = res?.data?.error || res.message || result['msg']
  })
  .catch((err) => {
    console.log('Network Error!')
  })

  return result;
}